import clsx from "clsx";

interface Props {
  children: React.ReactNode;
  align?: "start" | "end";
  className?: string;
}

export const ActionButtonGroup = ({ children, align = "end", className }: Props) => (
  <div
    className={clsx(
      "mt-2 flex gap-1",
      {
        "justify-start": align === "start",
        "justify-end": align === "end",
      },
      className,
    )}
  >
    {children}
  </div>
);
